import React from 'react';
import { Popover } from 'antd';

function HRPopover({ ...rest }) {
  return <Popover {...rest} />;
}

export default HRPopover;
